// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c72e2226","239":"e293f13c","453":"0b8eeedd","732":"a8e0f7b0"}[chunkId] + ".chunk.js";
};